/* eslint-disable prefer-const */

import { sortList, validateProduct } from '@gameday/common/factories/filter'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import CustomButton from '../Button'
import Card from './Card'

const Wrapper = styled.div`
  padding: 50px 0 44px;
  background-color: var(--grey-section-bg);
  @media only screen and (max-width: 540px) {
    padding: 30px 0 30px;
  }
`
const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 34px;
  @media only screen and (max-width: 540px) {
    padding: 0 20px;
  }
`

const ViewLink = styled.a`
  font-weight: 500;
  text-decoration: underline;
  color: ${props => props.color && props.color};
  &:hover {
    opacity: 0.5;
  }
  @media only screen and (max-width: 540px) {
    font-size: 14px;
  }
`

const NavHeading = styled.span`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 420px) {
    flex-wrap: wrap;
    a {
      margin: 10px 0;
    }
  }
`

const Title = styled.h2`
  font-size: 25px;
  color: var(--dark-text);
  font-weight: 700;
  margin: 0 24px 0 0;
  @media only screen and (max-width: 540px) {
    font-size: 16px;
  }
`
const CardScroll = styled.div`
  width: 100%;
  margin: 20px 0;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

const ScrollButtons = styled.div`
  display: flex;
  width: 68px;
  height: 38px;
  .MuiButton-root {
    display: 'none';
    &.rightscroll {
      margin-left: auto;
    }
  }
`

const Cards = styled.div`
  display: ${props => (props.view ? 'grid' : 'inline-flex')};
  justify-items: ${props => props.view && 'start'};
  grid-gap: 15px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  align-items: stretch;
  padding: 0 34px;
  div:not(:last-child) {
    margin-right: ${props => !props.view && '15px'};
  }
  @media only screen and (max-width: 540px) {
    padding: 0 20px;
  }
`

const Products = ({ background, color, products, signupURL, title }) => {
  const [showScrollRight, setShowScrollRight] = useState(true)
  const [showScrollLeft, setShowScrollLeft] = useState(false)

  const [filteredProducts, setFilteredProducts] = useState([])

  function windowResize() {
    const scroller = document.getElementById('cardScroll')
    if (window.innerWidth === scroller.scrollWidth) {
      setShowScrollRight(false)
      setShowScrollLeft(false)
    } else {
      setShowScrollRight(true)
    }
  }

  useEffect(() => {
    windowResize()
    window.addEventListener('resize', windowResize)
    return _ => {
      window.removeEventListener('resize', windowResize)
    }
  }, [])

  useEffect(() => {
    setFilteredProducts(sortList(products.filter(p => validateProduct(p))))
  }, [products])

  const handleScroll = e => {
    const element = e.target
    if (element.scrollWidth - element.scrollLeft === element.clientWidth) {
      setShowScrollRight(false)
    } else if (element.scrollLeft === 0) {
      setShowScrollLeft(false)
    } else {
      setShowScrollRight(true)
      setShowScrollLeft(true)
    }
  }
  // biome-ignore lint/correctness/noUnusedVariables: TODO
  const scrollLeft = e => {
    const scroller = document.getElementById('cardScroll')
    scroller.scrollBy(-347, 0)
  }
  // biome-ignore lint/correctness/noUnusedVariables: TODO
  const scrollRight = e => {
    const scroller = document.getElementById('cardScroll')
    scroller.scrollBy(347, 0)
  }
  const [viewAll, setViewAll] = useState(false)
  const handleViewAll = e => {
    e.preventDefault()
    setViewAll(!viewAll)
    setShowScrollRight(!showScrollRight)
  }
  return (
    <Wrapper>
      <Nav>
        <NavHeading>
          <Title>{title}</Title>
          {(showScrollLeft || showScrollRight || viewAll) && (
            <ViewLink href="#" onClick={handleViewAll} color={background}>
              {!viewAll ? 'View all' : 'Close'}
            </ViewLink>
          )}
        </NavHeading>
        {!viewAll && (
          <ScrollButtons>
            <CustomButton className="leftscroll" onClick={scrollLeft} hasIcon showButton={showScrollLeft}>
              <ChevronLeft />
            </CustomButton>
            <CustomButton className="rightscroll" onClick={scrollRight} hasIcon showButton={showScrollRight}>
              <ChevronRight />
            </CustomButton>
          </ScrollButtons>
        )}
      </Nav>
      <CardScroll onScroll={e => handleScroll(e)} id="cardScroll">
        <Cards view={viewAll}>
          {/** biome-ignore lint/correctness/noUnusedFunctionParameters: TODO */}
          {filteredProducts.map((product, i) => {
            const signupLink = `${signupURL}?product=${product.sfid}`
            return (
              <Card
                title={product.name}
                description={product.description}
                currencyCode={product.currencyCode}
                price={product.price}
                background={background}
                color={color}
                href={product.href || signupLink}
                view={viewAll}
                key={product.id || product.sfid}
                target="_blank"
              />
            )
          })}
        </Cards>
      </CardScroll>
    </Wrapper>
  )
}

Products.defaultProps = {
  title: 'Choose an event product',
}

export default Products
